import { httpClient } from '@/shared/services/http'
import { API_ENDPOINTS } from '@/shared/constants'

export interface UploadLogoPayload {
    data: string
    fileName: string
    contentType?: string
}

export interface BrandingConfigPayload {
    logo: string
    config_json: {
        platform_name: string
        platform_slogan: string
    }
    modified_by: string
}

export const brandingApi = {
    uploadLogo: async (payload: UploadLogoPayload): Promise<string> => {
        const response = await httpClient.post<any>(API_ENDPOINTS.UPLOADS.IMAGES, payload)

        // Expected response contains URL where logo is stored
        const uploadedUrl: string =
            response?.data?.url ||
            response?.data?.data?.url ||
            response?.data ||
            ''

        if (!uploadedUrl || typeof uploadedUrl !== 'string') {
            throw new Error('Backend did not return uploaded logo URL')
        }

        return uploadedUrl
    },

    updateBrandingConfig: async (payload: BrandingConfigPayload): Promise<void> => {
        await httpClient.patch(API_ENDPOINTS.AUTH.GET_UI_CONFIG, payload)
    },
}
